import(/* webpackMode: "eager", webpackExports: ["TermlyPolicy","PrivacyPolicyDataId"] */ "/codebuild/output/src2103436129/src/apps/wrap.gifts/src/services/Termly/TermlyPolicy.tsx");
